<template>
  <div>
    <v-card class="pa-5 mb-5 elevation-hb">
      <v-row class="mb-5" align="center" justify="center">
        <v-col>
          <h3><v-icon large>mdi-history</v-icon> Consolidação Histórica</h3>
        </v-col>
        <v-col class="text-right" cols="">
          <v-select
            v-model="selected"
            hide-details
            label="Filtrar Sellers"
            outlined
            dense
            item-text="sellerId"
            item-value="SellerId"
            :items="sellers"
          ></v-select>
        </v-col>
        <v-col class="text-right" cols="">
          <v-menu
            ref="menu"
            v-model="menu"
            :close-on-content-click="true"
            :nudge-right="40"
            transition="scale-transition"
            offset-y
            max-width="290px"
            min-width="290px"
          >
            <template v-slot:activator="{ on }">
              <v-text-field
                v-model="date"
                label="Mês de Referência"
                prepend-icon="mdi-calendar"
                readonly
                outlined
                dense
                hide-details
                v-on="on"
              ></v-text-field>
            </template>
            <v-date-picker
              v-model="date"
              type="month"
              no-title
              scrollable
              locale="pt-br"
            >
            </v-date-picker>
          </v-menu>
        </v-col>
        <!-- <v-col class="text-right" cols="">
          <v-btn
            :disabled="!date || !selected"
            @click="loadData"
            :dark="date && selected"
            class="mr-2"
            color="primary"
            depressed
            ><v-icon color="white" small class="mr-1">mdi-magnify</v-icon>Buscar</v-btn
          >
        </v-col>
        <v-col class="text-right" cols="2">
          <v-btn 
            depressed 
            color="primary" 
            class="text-center mr-1" 
            :disabled="!items.length" 
            :dark="items.length" 
            @click="downloadCSV()" 
            block
          >
            <v-icon small class="mx-2">mdi-magnify</v-icon>
            Exportar CSV
          </v-btn>
        </v-col> -->
      </v-row>
      <v-divider class="my-3"></v-divider>
      <v-row>
        <v-col class="text-right">
          <v-btn
            :disabled="!date || !selected"
            @click="loadData"
            :dark="date && selected"
            class="mr-2"
            color="primary"
            depressed
            ><v-icon color="white" small class="mr-1">mdi-magnify</v-icon>Buscar</v-btn
          >
          <v-btn
            :disabled="!items.length"
            @click="downloadCSV()"
            color="primary"
            depressed
            :dark="items.length"
            ><v-icon color="white" small class="mr-1">mdi-file</v-icon>Exportar CSV </v-btn
          >
        </v-col>
      </v-row>

      <v-divider class="my-3"></v-divider>

      <v-data-table
        :items="items"
        :headers="headers"
        :loading="loading"
        ::items-per-page="100"
        fixed-header
      >
        <template v-slot:[`item.totalValue`]="{ item }">
          {{ item.totalValue | formatFullMoney }}
        </template>
        <template v-slot:[`item.liquidValue`]="{ item }">
          {{ item.liquidValue | formatFullMoney }}
        </template>
        <template v-slot:[`item.movementDate`]="{ item }">
          {{ item.movementDate | formatFullDate }}
        </template>
        <template v-slot:[`item.tax`]="{ item }">
          {{ item.tax | formatFullMoney }}
        </template>
        <template v-slot:[`item.installmentValue`]="{ item }">
          {{ item.installmentValue | formatFullMoney }}
        </template>
      </v-data-table>
    </v-card>
  </div>
</template>

<script>
import axios from 'axios'
import { baseApiUrl, showError } from '@/global'

export default {
  watch: {
    selected () {
      this.loadData()
    }
  },
  data: () => ({
    items: [],
    sellers: [],
    headers: [
      { text: 'Pedido', value: 'orderIdMarketplace' },
      { text: 'Order Id seller', value: 'orderIdSeller' },
      { text: 'Seller', value: 'sellerId' },
      { text: 'Número da nota', value: 'orderNfe' },
      { text: 'Pagamento', value: 'payment' },
      { text: 'Número da parcela', value: 'installmentNumber' },
      { text: 'Quantidade de parcela', value: 'installmentAmount' },
      { text: 'Valor da parcela', value: 'installmentValue' },
      { text: 'Valor total', value: 'totalValue' },
      { text: 'Taxa', value: 'tax' },
      { text: 'Valor líquido', value: 'liquidValue' },
      { text: 'NSU', value: 'nsu' },
      { text: 'Data de movimentação', value: 'movementDate' }
    ],
    loading: false,
    date: null,
    menu: false
  }),
  methods: {
    loadData () {
      if (!this.date || !this.selected) return

      const url = `${baseApiUrl}/finantial/orderHistory`

      const d = new Date()
      let date = this.formatDate(d)
      if (this.date) {
        date = this.date
      }

      const sellerId = this.selected

      this.loading = true
      axios
        .get(url, { params: { date, sellerId } })
        .then(res => {
          this.items = res.data
          this.loading = false
        })
        .catch(showError)
    },
    loadSeller () {
      const url = `${baseApiUrl}/finantial/orderHistorySeller`

      this.loading = true
      axios
        .get(url)
        .then(res => {
          this.sellers = res.data
          console.log(res.data)
        })
        .catch(showError)
        .finally((this.loading = false))
    },
    encodeToISO88593 (str) {
      const buffer = new Uint8Array(str.length)
      for (let i = 0; i < str.length; i++) {
        buffer[i] = str.charCodeAt(i) // Isso é uma simplificação
      }
      return buffer
    },

    exportCSV () {
      let csv = ''
      // header
      this.headers.forEach(header => {
        csv += `${header.text},`
      })
      csv = csv.slice(0, -1) + '\n' // remove last comma and add newline

      // content
      this.items.forEach(item => {
        this.headers.forEach(header => {
          csv += `"${item[header.value]}",`
        })
        csv = csv.slice(0, -1) + '\n' // remove last comma and add newline
      })

      // Convert CSV string to iso-8859-3-like encoding
      const csvAsISO88593 = this.encodeToISO88593(csv)

      // Create a blob and download
      const blob = new Blob([csvAsISO88593], {
        type: 'text/csv;charset=iso-8859-3'
      })
      const link = document.createElement('a')
      link.href = URL.createObjectURL(blob)
      link.download = 'export.csv'
      document.body.appendChild(link)
      link.click()
      document.body.removeChild(link)
    },
    formatDate (date) {
      var d = new Date(date),
        month = '' + (d.getMonth() + 1),
        day = '' + d.getDate(),
        year = d.getFullYear()
      if (month.length < 2) month = '0' + month
      if (day.length < 2) day = '0' + day
      return [year, month].join('-')
    },
    downloadCSV() {
      const data = this.items
      const fileName = 'download-consolidacao-historica'
      const csv = this.convertArrayOfObjectsToCSV(data)
      const link = document.createElement('a')
      link.href = 'data:text/csv;charset=utf-8,' + encodeURI(csv)
      link.download = fileName + '.csv'
      link.click()
    },
    convertArrayOfObjectsToCSV(data) {
      const columnDelimiter = ','
      const lineDelimiter = '\n'
      const keys = Object.keys(data[0])

      let result = ''
      result += keys.join(columnDelimiter)
      result += lineDelimiter

      data.forEach((item) => {
        let ctr = 0
        keys.forEach((key) => {
          if (ctr > 0) result += columnDelimiter
          result += item[key]
          ctr++
        })
        result += lineDelimiter
      })

      return result
    },
  },

  mounted () {
    this.loadData()
    this.loadSeller()
  }
}
</script>

<style></style>
